export class AuthConstants{
    public static readonly AUTH = 'TTObesity.userDataKey';
}
